module.exports = __webpack_public_path__ + "assets/b124.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b124.png
// module id = 597
// module chunks = 0